module.exports = __webpack_public_path__ + "img/Jacques_reveal.f0c1d7a3.jpg";